import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { Row, Col, Divider, Typography, Space } from "antd";
import LionParcelLogo from "assets/img/shipment/lionparcel.png";
import OSDLogo from "assets/img/shipment/logoosd.png";

const { Text } = Typography;

export default function LionParcelResi({ data }) {
  const svgRefTop = useRef(null);
  const svgRefBot = useRef(null);

  useEffect(() => {
    if (!svgRefTop.current) return;
    try {
      JsBarcode(svgRefTop.current, data.NoResi, {
        format: "CODE128",
        displayValue: false,
        width: 1,
        height: 40,
        margin: 0,
      });
    } catch (err) {
      svgRefTop.current.innerHTML = "";
      console.error("Barcode render error:", err);
    }

    if (!svgRefBot.current) return;
    try {
      JsBarcode(svgRefBot.current, data.NoResi, {
        format: "CODE128",
        displayValue: true,
        width: 1,
        height: 20,
        fontSize: 9,
        margin: 0,
      });
    } catch (err) {
      svgRefBot.current.innerHTML = "";
      console.error("Barcode render error:", err);
    }
  }, [data]);

  return (
    <div
      style={{
        width: "110mm",
        height: "150mm",
        padding: "3mm",
        border: "1px solid #000",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {/* Kop/Header */}
      <Row justify="space-between" align="middle" wrap={false}>
        <Col flex="auto">
          <img src={OSDLogo} alt="LogoOSD" width={60} />
        </Col>
        <Col flex="none">
          <Space direction="vertical" align="end" size={0}>
            <img src={LionParcelLogo} alt="lionparcellogo" width={120} />
            <strong>
              {data.OriginCode} - {data.Code} | {data.UrsaCode}
            </strong>
          </Space>
        </Col>
      </Row>

      <Divider style={{ border: "1px solid #000", margin: "2px 0" }} />

      <Row gutter={[0, 0]}>
        <Col span={10}>
          <Text strong style={{ fontSize: 11 }}>
            {data.NoResi}
          </Text>
        </Col>
        <Col span={14} style={{ textAlign: "right" }}>
          <Text style={{ fontSize: 8 }}>
            {data.Kota} {data.Provinsi}
          </Text>
        </Col>
      </Row>

      <Row justify="space-around" wrap={false} align="middle">
        <Col flex={"auto"}>
          <svg ref={svgRefTop} />
        </Col>
        <Col flex={"none"}>
          <Space direction="vertical" align="end" size={0}>
            <Text style={{ fontSize: 10 }}>Tanggal Dicetak : </Text>
            <Text style={{ fontSize: 10 }}>
              {new Date(data.CreatedAt).toLocaleDateString()}
            </Text>
          </Space>
        </Col>
      </Row>

      <div
        style={{
          border: "1px solid #000",
          padding: "2px 4px",
          margin: "2px 0",
        }}
      >
        {/* Pengirim */}
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Text strong style={{ fontSize: 12 }}>
              Pengirim: {data.NamaPengirim}
            </Text>
          </Col>
        </Row>

        {/* Penerima */}
        <Row gutter={[0, 0]}>
          <Col span={16}>
            <Text strong style={{ fontSize: 12 }}>
              Penerima: {data.NamaPenerima}
            </Text>
          </Col>
          <Col span={8}>
            <Text strong style={{ fontSize: 12 }}>
              Telp. {data.NoHP}
            </Text>
          </Col>
          <Col span={24}>
            <Text style={{ fontSize: 11 }}>
              {data.AlamatPengiriman} , {data.Kota}, {data.Provinsi}
            </Text>
          </Col>
        </Row>

        <Row justify="space-between" align="middle" wrap={false}>
          <Col flex="auto">
            <Text style={{ fontSize: 11 }} strong>
              {data.TipeBarang || "Pecah Belah / Glassware"}
            </Text>
          </Col>
          <Col flex="none">
            <Text style={{ fontSize: 10 }}>Ext : {data.OrderId}</Text>
          </Col>
        </Row>
        {/* Pesanan */}
        <Row gutter={[0, 0]} style={{ borderTop: "1px solid #000" }}>
          <Col span={24}>
            <Text strong style={{ fontSize: 10 }}>
              Pesanan :&nbsp;
            </Text>
            <Text
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                fontSize: 9,
                maxHeight: "40mm",
                overflow: "hidden",
              }}
            >
              {data.Pesanan}
            </Text>
          </Col>
        </Row>
      </div>

      <Row wrap={false}>
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            padding: 4,
            textAlign: "center",
            backgroundColor: "#000",
            color: "#fff",
          }}
        >
          <Text style={{ fontSize: 14, color: "white" }} strong>
            NON COD
          </Text>
          <Text style={{ fontSize: 14, color: "white" }} strong>
            REGPACK
          </Text>
          <Text style={{ fontSize: 14, color: "white" }} strong>
            1/1
          </Text>
        </Col>
      </Row>
      {/* Info utama */}
      <Row gutter={[0, 0]} align={"middle"} wrap={false}>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text style={{ fontSize: 10 }}>Total Berat : {data.Berat} Kg</Text>
            <Text style={{ fontSize: 10 }}>Biaya Kirim : {data.Ongkir}</Text>
            <Text style={{ fontSize: 10 }}>
              Asuransi : {data.Asuransi || "-"}
            </Text>
          </Space>
        </Col>

        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text style={{ fontSize: 12 }} strong>
              GW : {data.Berat} Kg / {data.Berat} Kg
            </Text>
            <Text style={{ fontSize: 12 }} strong>
              VW :
            </Text>
          </Space>
        </Col>
      </Row>

      <Divider
        type="horizontal"
        style={{ border: "1px dashed #000", margin: "2px 0" }}
      />

      <div style={{ border: "1px solid #000", marginTop: 4 }}>
        <Row gutter={[0, 0]} align={"middle"}>
          <Col span={16}>
            <img src={LionParcelLogo} alt="lionparcellogo" width={80} />
            <svg ref={svgRefBot} />
          </Col>
          <Col span={8}>
            <Text style={{ fontSize: 18, marginRight: 8 }} strong>
              REGPACK
            </Text>
            <img src={OSDLogo} alt="LogoOSD" width={40} />
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Text strong style={{ fontSize: 9, textAlign: "center" }}>
              {new Date(data.CreatedAt).toLocaleDateString()}
            </Text>
          </Col>
          <Col span={6} align="center">
            <Text strong style={{ fontSize: 9, textAlign: "center" }}>
              {data.NoResi}
            </Text>
          </Col>

          <Col
            span={12}
            align="right"
            style={{ textAlign: "right", paddingRight: 4 }}
          >
            <Text style={{ fontSize: 8 }}>Total Berat : {data.Berat} Kg</Text>
            ,&nbsp;
            <Text style={{ fontSize: 8 }}>Biaya Kirim : {data.Ongkir}</Text>
          </Col>
          <Col span={24}>
            <Row>
              <Col span={12}>
                <Text style={{ fontSize: 9 }}>
                  Pengirim : {data.NamaPengirim}
                </Text>
              </Col>
              <Col span={12}>
                <Text style={{ fontSize: 9 }}>
                  Penerima : {data.NamaPenerima}
                </Text>
              </Col>
              <Col span={24}>
                <Text style={{ fontSize: 8 }}>
                  Tujuan : {data.Kota}, {data.Provinsi}
                </Text>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <style>
        {`
          @media print {
            @page {
              size: 110mm 150mm;
              margin: 0;
            }
            body {
              margin: 0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            div {
              page-break-inside: avoid;
            }
          }
        `}
      </style>
    </div>
  );
}
